import { useState } from "react";
import { Autocomplete } from "@mui/material";
import cn from "classnames";
import { useAppDispatch } from "../../../store/hooks";
import { addModelConfig } from "../../../store/ses/sesRobotSlice";
import useTranslate from "../../../hooks/useTranslate";
import { ROBOT_MODEL_SERVICE_TYPE_EXTENDED_LIST, ServiceTypeModelRobotExtended } from "../../../constants/robotConfigLists";
import { ServiceTypeModelRobot } from "../../../types/cloudTypes";
import { IFormAddingModelConfigProps } from "./FormAddingModelConfig.props";
import styles from "./FormAddingModelConfig.module.scss";
import { CustomMenuItem, CustomTextField } from "@/ui";
import { RenderOption } from "@/ui";

const FormAddingModelConfig = ({ changeFlgHandler, modelsListSmc, modelsListSee, modelsListTts }: IFormAddingModelConfigProps): JSX.Element => {
	const [selectType, setSelectType] = useState<ServiceTypeModelRobotExtended>("chooseType"); // тип
	const [inputModelName, setInputModelName] = useState<string>(""); // название модели

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	// функция сброса всех полей
	const resetInputAndSelect = (): void => {
		setSelectType("chooseType");
		setInputModelName("");
	};

	// обработчик добавления настроек модели
	const changeModelHandler = (): void => {
		if (inputModelName !== "") {
			dispatch(addModelConfig({ serviceType: selectType as ServiceTypeModelRobot, modelName: inputModelName }));
			changeFlgHandler("models"); // ставим флаг о несохраненных данных
			resetInputAndSelect(); // очищаем поля
		}
	};

	return (
		<div
			className={cn(styles.container, {
				[styles.containerOpacity]: selectType === "chooseType",
			})}
		>
			{/* тип */}
			<CustomTextField select fullWidth label={translate("select_type")} value={selectType} onChange={(e) => setSelectType(e.target.value as ServiceTypeModelRobot)}>
				{ROBOT_MODEL_SERVICE_TYPE_EXTENDED_LIST.map(({ type, translation }) => (
					<CustomMenuItem key={type} value={type} disabled={type === "chooseType"}>
						{translate(translation)}
					</CustomMenuItem>
				))}
			</CustomTextField>

			{/* модель */}
			{selectType !== "chooseType" && (
				<Autocomplete
					fullWidth
					freeSolo
					options={selectType === "smc" ? modelsListSmc : selectType === "see" ? modelsListSee : modelsListTts}
					value={inputModelName}
					onChange={(_, value) => setInputModelName(value ? value : "")}
					onBlur={changeModelHandler}
					onKeyDown={(e) => e.code === "Enter" && changeModelHandler()}
					renderInput={(params) => <CustomTextField {...params} label={translate("input_model")} onChange={(e) => setInputModelName(e.target.value)} />}
					renderOption={(props, option) => {
						return (
							<RenderOption {...props} key={option}>
								{option}
							</RenderOption>
						);
					}}
				/>
			)}
		</div>
	);
};

export default FormAddingModelConfig;
